import { render, staticRenderFns } from "./access-right.vue?vue&type=template&id=6bae49ca&scoped=true&"
import script from "./access-right.vue?vue&type=script&lang=js&"
export * from "./access-right.vue?vue&type=script&lang=js&"
import style0 from "./access-right.vue?vue&type=style&index=0&id=6bae49ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae49ca",
  null
  
)

export default component.exports